import React from 'react';

export type FAQ = { title: string; text?: string; bulletPoints?: string[] };

type FaqProps = {
  faq: FAQ;
  index: number;
  expanded: boolean;
  setExpanded: (value: boolean) => void;
  faqOnClick: (value: string) => void;
};

export default function Faq({ faq, index, expanded, setExpanded, faqOnClick }: FaqProps) {
  return (
    <div data-testid="faq" className="FAQ faq-line">
      <div
        data-testid={`faq-line-${index}`}
        className={`faq-header-row is-clickable ${expanded ? 'faq-expanded' : ''}`}
        automationid={`BCA_Div_FAQ_${index}`}
        onClick={() => {
          if (!expanded && faqOnClick) {
            faqOnClick(faq.title);
          }

          setExpanded(!expanded);
        }}
      >
        <div className="columns is-mobile is-vcentered">
          <div className="column is-narrow">
            <div className="icon-circle-container">
              <span className="is-icon-6 icon-accounting-bills" style={{ color: '#E60000' }}></span>
            </div>
          </div>
          <div className="column faq-title">{faq.title}</div>
          <div className="column is-narrow">
            <span className={`is-icon-5 icon-chevron-${expanded ? 'up' : 'down'}-thin`}></span>
          </div>
        </div>
      </div>
      {expanded && (
        <div
          automationid={`BCA_Div_FAQ_Text_${index}`}
          data-testid={`faq-text-${index}`}
          className="faq-text-container"
        >
          {faq.text && <div className="faq-text">{faq.text}</div>}
          {faq.bulletPoints && (
            <ul className="faq-list" style={{ marginTop: faq.text ? '20px' : '0' }}>
              {faq.bulletPoints.map((point, index) => (
                <li key={index} className="columns is-mobile is-vcentered">
                  <div className="column is-narrow">
                    <div className="faq-bullet-point"></div>
                  </div>
                  <span className="column">{point}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
